import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-accounts-dialog',
  templateUrl: './accounts-dialog.component.html',
  styleUrls: ['./accounts-dialog.component.scss'],
})
export class AccountsDialogComponent {
  @Input() accountIds?: string

  constructor(public activeModal: NgbActiveModal) {}

  onCopy() {
    if (this.accountIds) navigator.clipboard.writeText(this.accountIds)
  }
}
